import template from './cellGridMotion.html';

/* @ngInject */
function CellGridMotionController(
  $scope,
  CameraService,
  growl,
) {
  const vm = this;

  const DEFAULT_MOTION_CONFIG = {
    settings: {
      duration: {
        pre: 2000,
        post: 2000
      },
      delay: 1000,
      count: 1,
      sensitivity: 50
    }
  };

  let growlMessage;
  let backupMotionConfig;


  // //////////////// //
  // PUBLIC VARIABLES //
  // //////////////// //
  vm.showOverlays = true;
  vm.options = {};
  vm.cellGridModel = new Set();

  // //////////////// //
  // PUBLIC FUNCTIONS //
  // //////////////// //
  vm.$onInit = init;
  vm.$onDestroy = destroy;
  vm.$postLink = postLink;
  vm.testAlarm = testAlarm;
  vm.reset = reset;
  vm.saveProfile = saveProfile;
  vm.toggleOverlayAction = toggleOverlayAction;
  vm.updateCellGridModel = updateCellGridModel;
  vm.updateLightZoneOverlay = updateLightZoneOverlay;

  function init() {
    _.assign(vm, vm.resolve);

    vm.showDetectionBox = false;

    setCellGridSelectorModelAndOptions();

    vm.loadingSpinners = true;
  }

  function postLink() {
    const saveBtnWatcher = $scope.$watch(() => document.getElementById('save-btn'), (newV) => {
      if (newV) {
        saveBtnWatcher();

        const saveBtn = $('#cellGridMotion-settings-container #save-btn');
        const enableContainer = $('#cellGridMotion-settings-container #enable-container');
        saveBtn
          .on('mouseenter', () => {
            if (!vm.motionConfig.settings.enabled) {
              enableContainer.addClass('annoying-disable-notification');
            }
          })
          .on('mouseleave', () => {
            enableContainer.removeClass('annoying-disable-notification');
          });
      }
    });
  }

  function setCellGridSelectorModelAndOptions() {
    _.defaultsDeep(vm.motionConfig, DEFAULT_MOTION_CONFIG);
    backupMotionConfig = _.cloneDeep(vm.motionConfig);

    vm.cellGridModel.clear();

    const { grid = '' } = vm.motionConfig?.settings || {};

    const { width, height } = vm.motionConfig?.structure || {};

    _.merge(vm.options, {
      columns: width,
      rows: height
    });

    const cellCount = width * height;
    const total = Math.min(cellCount, grid.length);

    for (let idx = 0; idx < total; idx++) {
      if (parseInt(grid[idx], 10)) {
        const col = idx % width;
        const row = Math.floor(idx / width);
        vm.cellGridModel.add(`${col}.${row}`);
      }
    }
  }

  function updateCellGridModel(update) {
    vm.cellGridModel.clear();
    update.forEach(vm.cellGridModel.add, vm.cellGridModel);
  }

  /**
   * Requests to trigger the camera's alarm and flashes a red alarm on the svg as visual indication of success
   *
   * @returns {undefined}
   */
  function testAlarm() {
    growlMessage = growl.info('Attempting to trigger test alarm...', { disableCloseButton: true });
    CameraService
      .testAlarm(vm.camId)
      .then(() => {
        growlMessage.destroy();
        return growl.success('Test alarm triggered successfully');
      })
      .catch((err) => {
        growlMessage.destroy();
        return growl.error(err.message, {
          title: 'Test alarm could not be triggered:'
        });
      });
  }

  /**
   * Uses vmd type to determine which reset method to call
   *
   * @returns {undefined}
   */
  function reset() {
    vm.motionConfig = _.cloneDeep(backupMotionConfig);
    setCellGridSelectorModelAndOptions();
    // new reference to trigger ngOnChanges in cell-grid-selector
    vm.cellGridModel = new Set(vm.cellGridModel);
  }

  /**
   * Validates the existence of a profile name then calls the appropriate save method
   *
   * @returns {undefined}
   */
  function saveProfile() {
    growlMessage = growl.info('Attempting to save profile...', { disableCloseButton: true });

    // convert cellGridModel back into binarystring
    const { width, height } = vm.motionConfig?.structure || {};
    const cellCount = width * height;
    const grid = Array(cellCount).fill(0);

    vm.cellGridModel.forEach((selected) => {
      const [col, row] = selected.split('.').map(Number);
      const idx = (row * width) + col;
      grid[idx] = 1;
    });

    _.set(vm.motionConfig, ['settings', 'grid'], grid.join(''));

    return CameraService.setMotionDetectionConfig(vm.camId, vm.motionConfig)
      .then(() => {
        backupMotionConfig = _.cloneDeep(vm.motionConfig);
        growlMessage.destroy();
        return growl.success('Profile successfully saved');
      })
      .catch((err) => {
        growlMessage.destroy();
        return growl.error(err.message, {
          title: 'Profile could not be saved:'
        });
      });
  }

  function toggleOverlayAction(show) {
    vm.showOverlays = show;
  }

  function destroy() {
    if (growlMessage) { growlMessage.destroy() }
  }

  function updateLightZoneOverlay($event) {
    $scope.$apply(() => {
      vm.lightZoneOverlay = $event;
    });
  }
}

export default {
  name: 'cellGridMotion',
  template,
  controller: CellGridMotionController,
  controllerAs: 'CGMCtrl',
  bindings: {
    resolve: '<',
    dismiss: '&'
  }
};
